/**
 * @generated SignedSource<<032c4f870f8bb4df5c92f425ed5ef42c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerReviewsModalContent_viewer$data = {
  readonly feedbackFormPhotoUpload: boolean | null;
  readonly orderFeedbackMultiple: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly item: {
          readonly contemporaryTrackingString: string;
          readonly serviceId: string | null;
          readonly title: string | null;
        } | null;
        readonly publicNote: {
          readonly language?: string | null;
        } | null;
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"Review_review">;
      } | null;
    } | null> | null;
    readonly metadata: {
      readonly aggregatedFeedback: {
        readonly overallExperience: {
          readonly mean: number | null;
        } | null;
      } | null;
    } | null;
    readonly numberOfPages: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"SellerReviewsModalHeader_reviews">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SellerReviewsModalHeader_viewer">;
  readonly " $fragmentType": "SellerReviewsModalContent_viewer";
};
export type SellerReviewsModalContent_viewer$key = {
  readonly " $data"?: SellerReviewsModalContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerReviewsModalContent_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "orderByHighest"
    },
    {
      "kind": "RootArgument",
      "name": "orderByLowest"
    },
    {
      "kind": "RootArgument",
      "name": "orderByNewest"
    },
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./SellerReviewsModalContentRefetchQuery.graphql')
    }
  },
  "name": "SellerReviewsModalContent_viewer",
  "selections": [
    {
      "alias": "feedbackFormPhotoUpload",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "feedbackFormPhotoUpload"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"feedbackFormPhotoUpload\")"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "excludeInAppealProcess",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "excludePrivateItemReviews",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 3
        },
        {
          "kind": "Variable",
          "name": "orderByHighest",
          "variableName": "orderByHighest"
        },
        {
          "kind": "Variable",
          "name": "orderByLowest",
          "variableName": "orderByLowest"
        },
        {
          "kind": "Variable",
          "name": "orderByNewest",
          "variableName": "orderByNewest"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "sellerId",
          "variableName": "sellerId"
        }
      ],
      "concreteType": "OrderFeedbackMultipleQueryConnection",
      "kind": "LinkedField",
      "name": "orderFeedbackMultiple",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderFeedbackMultipleQueryMetadata",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AggregatedOrderFeedbackType",
              "kind": "LinkedField",
              "name": "aggregatedFeedback",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AggregatedOrderFeedbackQuestionType",
                  "kind": "LinkedField",
                  "name": "overallExperience",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "mean",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfPages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderFeedbackMultipleQueryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrderFeedback",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "item",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contemporaryTrackingString",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "publicNote",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "language",
                          "storageKey": null
                        }
                      ],
                      "type": "StandardQuestion",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Review_review"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SellerReviewsModalHeader_reviews"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SellerReviewsModalHeader_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "99b90e6bf4639d2a0abb398e4842fe31";

export default node;
